module.exports = __webpack_public_path__ + "img/about.a7ce0ab0.png";